import { Segmented } from 'antd';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllConditionsListSlice } from 'src/modules/SuperAdmin/store/slices';
import AppointmentStatusMappingPage from './AppointmentStatusMapping/AppointmentStatusMapping.page';
import ColumnMappingPage from './ColumnMapping/ColumnMapping.page';
import ConditionMappingPage from './ConditionMapping/ConditionMapping.page';
import LookbackPeriodPage from './LookbackPeriod/LookbackPeriod.page';
import ProviderMappingPage from './ProviderMapping/ProviderMapping.page';
import { getFromStorage, storeInLocal } from '../../../../../lib/storage';
import OrganizationFilter from '../SuperAdmin/OrganizationFilter';
import DACCSVSettings from './DACCSVSettings/DACCSVSettings.page';

const CSVUpload = ({ isMinimized }) => {
  const [activeButton, setActiveButton] = useState(() => {
    return getFromStorage('csvUploadSegment') || 'Column mapping';
  });
  const { currentPractitioner } = useSelector(
    (state) => state?.practitionerState
  );
  const [isPractitionerHomePage, setIsPractitionerHomePage] = useState(true);
  const [
    selectedPractitionerOrganizationName,
    setSelectedPractitionerOrganizationName,
  ] = useState(null);
  const [
    selectedPractitionerOrganization,
    setSelectedPractitionerOrganization,
  ] = useState(null);
  const dispatch = useDispatch();

  const superAdminButton = [
    {
      label: 'Column mapping',
      isActive: activeButton === 'Column mapping',
      onClick: () => setActiveButton('Column mapping'),
    },
    {
      label: 'Provider mapping',
      isActive: activeButton === 'Provider mapping',
      onClick: () => setActiveButton('Provider mapping'),
    },
    {
      label: 'Appointment status mapping',
      isActive: activeButton === 'Appointment status mapping',
      onClick: () => setActiveButton('Appointment status mapping'),
    },
    {
      label: 'Condition mapping',
      isActive: activeButton === 'Condition mapping',
      onClick: () => setActiveButton('Condition mapping'),
    },
    {
      label: 'Lookback period',
      isActive: activeButton === 'Lookback period',
      onClick: () => setActiveButton('Lookback period'),
    },
    {
      label: 'DAC CSV settings',
      isActive: activeButton === 'DAC CSV settings',
      onClick: () => setActiveButton('DAC CSV settings'),
    },
  ];

  const handleSegmentedTabChange = (value) => {
    setActiveButton(value);
    dispatch(getAllConditionsListSlice(null));
    storeInLocal('csvUploadSegment', value);
  };

  return (
    <div className={`page-wrapper`}>
      <OrganizationFilter />
      <div className="lg:flex gap-3 justify-between py-3 px-1 items-center ">
        <div className="lg:flex segmented_schedule  rounded-lg w-fit">
          <Segmented
            options={superAdminButton.map((button) => ({
              label: button.label,
              value: button.label,
            }))}
            value={activeButton}
            onChange={(value) => {
              handleSegmentedTabChange(value);
            }}
          />
        </div>
      </div>
      <div>
        {activeButton === 'Column mapping' && (
          <>
            <ColumnMappingPage />
          </>
        )}
        {activeButton === 'Provider mapping' && (
          <>
            <ProviderMappingPage />
          </>
        )}
        {activeButton === 'Appointment status mapping' && (
          <>
            <AppointmentStatusMappingPage />
          </>
        )}
        {activeButton === 'Condition mapping' && (
          <>
            <ConditionMappingPage />
          </>
        )}
        {activeButton === 'Lookback period' && (
          <>
            <LookbackPeriodPage />
          </>
        )}
        {activeButton === 'DAC CSV settings' && (
          <>
            <DACCSVSettings />
          </>
        )}
      </div>
    </div>
  );
};

export default CSVUpload;
